/**
 * Opt-in timing for competitive score submission.
 * Set REACT_APP_SCORE_SUBMIT_DEBUG=true to log per-submit span breakdowns.
 */

const SCORE_SUBMIT_DEBUG =
  typeof process !== 'undefined' && process.env.REACT_APP_SCORE_SUBMIT_DEBUG === 'true';

function scoreSubmitDebugEnabled() {
  return SCORE_SUBMIT_DEBUG;
}

/**
 * Lightweight span collector for a single score submission.
 */
export function createScoreSubmitTimer(courtNumber) {
  const spans = {};
  const wallStart = typeof performance !== 'undefined' ? performance.now() : Date.now();
  let lastMark = wallStart;

  const mark = (name) => {
    const now = typeof performance !== 'undefined' ? performance.now() : Date.now();
    spans[name] = Math.round(now - lastMark);
    lastMark = now;
  };

  const finish = (extra = {}) => {
    if (!scoreSubmitDebugEnabled()) return;
    const totalMs = Math.round(
      (typeof performance !== 'undefined' ? performance.now() : Date.now()) - wallStart
    );
    console.info('[ScoreSubmit:summary]', {
      courtNumber,
      totalMs,
      spans: { ...spans },
      ...extra,
    });
  };

  return { mark, finish, spans };
}

export function scoreSubmitDebugLog(label, payload) {
  if (!scoreSubmitDebugEnabled()) return;
  console.info(`[ScoreSubmit:${label}]`, payload);
}

export function scoreSubmitSyncDebugLog(label, payload) {
  if (!scoreSubmitDebugEnabled()) return;
  console.info(`[ScoreSubmitSync:${label}]`, payload);
}

/** One-time mount ping so devs can confirm the env flag reached the bundle. */
export function logScoreSubmitDebugReady(context = '') {
  if (!scoreSubmitDebugEnabled()) return;
  console.info('[ScoreSubmit] Debug logging enabled', context ? { context } : '');
}

export { scoreSubmitDebugEnabled };
